import type { ReactElement } from 'react'
import { ToastStack } from '../../Global/Interactions/Toast/ToastStack'

export const Footer = (): ReactElement => {
  return <ToastStack />
}
